import { useCallback, useState } from "react";

export const NAV_COLLAPSED_KEY = "atlas.nav.collapsed";

/**
 * Collapse state for the navigation sidebar. Mirrors `useDensity`: state is
 * seeded from localStorage and persisted on toggle, with a try/catch guard so
 * quota/privacy-mode failures never break the UI. Default = expanded.
 */
export function useNavCollapsed(): [boolean, () => void] {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem(NAV_COLLAPSED_KEY) === "1";
  });

  const toggle = useCallback((): void => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(NAV_COLLAPSED_KEY, next ? "1" : "0");
      } catch {
        /* quota / privacy mode — ignore */
      }
      return next;
    });
  }, []);

  return [collapsed, toggle];
}
